<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-15 15:48:34
 * @LastEditTime: 2020-09-15 16:16:17
 * @Description: 车辆信息页面
-->
<template>
  <div class="hello">
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索车辆信息..."
        @on-change="searchVehicle"
        style="width: 250px; margin-right: auto"
      >
      <Button
        slot="append"
        icon="ios-search"
        @click="searchVehicle"
      ></Button>
      </Input>
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="15"
        @on-change="loadVehicle"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button
        v-if="
          user.superAdmin ||
          arrayIntersection(['deliveryLeader'], user.simpleRole).length > 0
        "
        type="primary"
        @click="$refs.EditVehicleDrawer.openDrawer()"
      >新增车辆信息</Button>
    </div>
    <div
      class="table-wrapper"
      ref="tableWrapper"
    >
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="tableData"
        :height="tableHeight"
      ></Table>
    </div>
    <EditVehicleDrawer ref="EditVehicleDrawer" />
  </div>
</template>

<script>
import EditVehicleDrawer from "./EditVehicleDrawer.vue";
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import _ from "lodash";

export default {
  name: "Vehicle",
  components: { EditVehicleDrawer },
  props: {},
  data() {
    return {
      page: 0,
      searchText: "",
      tableHeight: 300,
      tableLoading: false,
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            ),
        },
        {
          title: "车牌",
          key: "plate",
          render: (h, params) => {
            if (
              this.user.superAdmin ||
              arrayIntersection(["deliveryLeader"], this.user.simpleRole)
                .length > 0
            ) {
              return h("div", [
                h(
                  "h4",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      color: "#42b983",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$refs.EditVehicleDrawer.openDrawer(params.row);
                      },
                    },
                  },
                  params.row.plate
                ),
              ]);
            }
            return h("span", params.row.plate);
          },
        },
        {
          title: "默认司机",
          key: "defaultDriver",
          render: (h, params) => h("span", params.row.defaultDriver.name),
        },
        {
          title: "工厂",
          key: "factory",
          render: (h, params) => h("span", params.row.factory.map(v => v.name).join('、')),
        },
        {
          title: "容量",
          key: "capacity",
          render: (h, params) => h("span", params.row.capacity),
        },
        {
          title: "仓位容积",
          key: "storageSection",
          minWidth: 200,
          render: (h, params) => {
            let text = "";
            params.row.storageSection.forEach((e) => {
              text += `${e.name}: ${e.capacity} `;
            });
            return h("span", text);
          },
        },
        {
          title: "是否被禁用",
          key: "invalid",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  color: "#ed4014",
                },
              },
              params.row.invalid ? "是" : ""
            );
          },
        },
      ],
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.vehicle.vehicleList,
      totalRows: (state) => state.vehicle.totalCounts,
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getVehicleList: "vehicle/getVehicleListAction",
      getFactorys: "factory/getFactorysAction",
    }),
    async loadVehicle(page) {
      if (page) this.page = page - 1;
      let api = { skip: this.page * 15, limit: 15 };
      if (this.searchText) api.searchText = this.searchText;

      try {
        this.tableLoading = true;
        await this.getVehicleList(api);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchVehicle: _.debounce(function () {
      this.page = 0;
      this.loadVehicle();
    }, 1000),
  },
  async created() {
    this.loadVehicle();
    await this.getFactorys();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>
